import React, { Component } from 'react'
import './Graph.css'
import ReactTable from 'react-table'
import 'react-table/react-table.css'

class Table extends Component {
  state = {
    data: [],
    columns: []
  }

  componentDidMount = () => {
    this._bind(this.props)
  }

  componentWillReceiveProps = (nextProps) => {
    this._bind(nextProps)
  }

  _bind = (props) => {
    if (props.data && props.data.length > 0) {
      this.setState({ columns: this._getColumns(props.data[0]), data: this._getData(props.data) }, () => {
        this._createHeader()
      })
    }
  }

  _createHeader = () => {
    let header = document.querySelector('div.rt-thead.-headerGroups')
    let clone = header.cloneNode(true)
    clone.querySelector('div > div.rt-th:nth-child(2)').innerText = 'ปัจจัยพื้นฐานนักเรียนยากจน'
    clone.querySelector('div > div.rt-th:nth-child(3)').innerText = 'สวัสดิการแห่งรัฐ'
    header.parentNode.insertBefore(clone, header.parentNode.firstChild)
  }

  _getData = (records) => {
    var data = []
    for (let [index, record] of records.entries()) {
      const fields = record._fields.filter(x => x.type === undefined)
      for (let field of fields) {
        const header = field.labels.join()
        for (let key in field.properties) {
          var obj = { id: index }
          obj[header + 'Attr'] = key.toLowerCase()
          obj[header + 'Val'] = field.properties[key]
          data.push(obj)
        }
      }
    }
    // clean up
    var result = []
    for (let d of data) {
      if (result.length === 0) {
        result.push(d)
      }
      else {
        var index = result.findIndex(x => Object.keys(x).join() === Object.keys(d).join() && x.id === d.id)
        if (index > -1) {
          result.push(d)
        }
        else {
          index = result.findIndex(x =>
            Object.keys(x).join().replace('id', '').indexOf(Object.keys(d).join().replace('id', '')) === -1
            && x.id === d.id
          )
          if (index > -1) result[index] = { ...result[index], ...d }
          else result.push(d)
        }
      }
    }
    // change id to name
    var map = {}
    for (let r of result) {
      if (typeof (r.id) === 'number') {
        var name = ''
        const index = result.findIndex(x => x.id === r.id && x.GuardianAttr === 'firstname')
        if (index > -1) {
          name = result[index].GuardianVal + ' ' + result[index + 1].GuardianVal
        }
        map[result[index].id] = name
      }
    }
    for (let r of result) r.id = map[r.id]
    return result
  }

  _getColumns = (record) => {
    var columns = [{
      Header: " ",
      columns: [
        { Header: "Student Name", accessor: "id" }
      ]
    }]
    const fields = record._fields.filter(x => x.type === undefined)
    for (let field of fields) {
      const header = field.labels.join()
      const highlight = this._getHighlight(field)
      if (header !== 'Student') columns.push({
        Header: header,
        columns: [{
          Header: "Attribute",
          accessor: header + "Attr",
          Aggregated: row => (<span>{highlight.key || ''}</span>)
        },
        {
          Header: "Value",
          accessor: header + "Val",
          Aggregated: row => (<span>{highlight.value || ''}</span>)
        }]
      })
    }
    return columns
  }

  _getHighlight = (field) => {
    if (!field.highlight) return {}
    var value = ''
    for (let key of field.highlight) value += field.properties[key] + ','
    return {
      key: field.highlight.join().toLowerCase(),
      value: value.substring(0, value.length - 1)
    }
  }

  render() {
    var { columns, data } = this.state
    const defaultCols = [{
      Header: "Name",
      columns: [{ Header: "Student Name", accessor: "id" }]
    }]
    if (columns.length === 0) columns = defaultCols
    return (
      <div className="PersonGraph" style={{ textAlign: 'left' }}>
        <ReactTable
          data={data}
          columns={columns}
          pivotBy={["id"]}
          defaultPageSize={10}
          className="-striped -highlight"
        />
      </div>
    )
  }
};

export default Table



// WEBPACK FOOTER //
// ./src/lib/components/Table.js